// extracted by mini-css-extract-plugin
export default {"trade-count":"mNlrK","tradeCount":"mNlrK","download-icon":"_1aCsg","downloadIcon":"_1aCsg","resell-button-wrapper":"u4BtZ","resellButtonWrapper":"u4BtZ"};